export interface EconomyKPI {
  id: string;
  label: string;
  value: string;
  rawValue: number;
  icon: string;
  trend: number;
  trendLabel: string;
  accent: 'primary' | 'accent' | 'secondary' | 'success' | 'warning';
  subtitle: string;
}

export interface MonthlyRevenuePoint {
  month: string;
  monthShort: string;
  radioRevenue: number;
  rfwRevenue: number;
  totalRevenue: number;
}

export interface TopEarningRadio {
  id: number;
  name: string;
  frequency: string;
  city: string;
  totalEarnings: number;
  ownRevenue: number;
  rfwRevenue: number;
  campaigns: number;
  sponsors: number;
  plan: string;
  trend: number;
}

export interface RevenueStream {
  id: string;
  label: string;
  amount: number;
  percentage: number;
  icon: string;
  color: string;
  bgColor: string;
}

export interface EconomyData {
  kpis: EconomyKPI[];
  monthlyRevenue: MonthlyRevenuePoint[];
  topEarningRadios: TopEarningRadio[];
  revenueStreams: RevenueStream[];
}

export const economyData: EconomyData = {
  kpis: [
    {
      id: 'ingresos-radios',
      label: 'Ingresos Radios',
      value: '$3,847,200',
      rawValue: 3847200,
      icon: 'ri-radio-line',
      trend: 18.4,
      trendLabel: 'vs año anterior',
      accent: 'success',
      subtitle: 'Revenue total anual de todas las radios',
    },
    {
      id: 'ingresos-rfw',
      label: 'Ingresos RFW',
      value: '$1,284,500',
      rawValue: 1284500,
      icon: 'ri-building-2-line',
      trend: 24.7,
      trendLabel: 'vs año anterior',
      accent: 'primary',
      subtitle: 'Comisiones, licencias y revenue share RFW',
    },
    {
      id: 'anunciantes',
      label: 'Anunciantes',
      value: '486',
      rawValue: 486,
      icon: 'ri-advertisement-line',
      trend: 32.1,
      trendLabel: 'vs año anterior',
      accent: 'accent',
      subtitle: 'Anunciantes activos en la red',
    },
    {
      id: 'patrocinadores',
      label: 'Patrocinadores',
      value: '1,203',
      rawValue: 1203,
      icon: 'ri-hand-heart-line',
      trend: 15.8,
      trendLabel: 'vs año anterior',
      accent: 'secondary',
      subtitle: 'Patrocinadores activos totales',
    },
    {
      id: 'campanas',
      label: 'Campañas Activas',
      value: '842',
      rawValue: 842,
      icon: 'ri-megaphone-line',
      trend: 28.3,
      trendLabel: 'vs año anterior',
      accent: 'warning',
      subtitle: 'Campañas en curso en la plataforma',
    },
    {
      id: 'revenue-share',
      label: 'Revenue Share',
      value: '$1,640,800',
      rawValue: 1640800,
      icon: 'ri-percent-line',
      trend: 35.2,
      trendLabel: 'vs año anterior',
      accent: 'success',
      subtitle: 'Revenue distribuido vía Red Publicitaria',
    },
  ],
  monthlyRevenue: [
    { month: 'Ene 2026', monthShort: 'Ene', radioRevenue: 298000, rfwRevenue: 98000, totalRevenue: 396000 },
    { month: 'Feb 2026', monthShort: 'Feb', radioRevenue: 312000, rfwRevenue: 102000, totalRevenue: 414000 },
    { month: 'Mar 2026', monthShort: 'Mar', radioRevenue: 335000, rfwRevenue: 110000, totalRevenue: 445000 },
    { month: 'Abr 2026', monthShort: 'Abr', radioRevenue: 348000, rfwRevenue: 115000, totalRevenue: 463000 },
    { month: 'May 2026', monthShort: 'May', radioRevenue: 361000, rfwRevenue: 120000, totalRevenue: 481000 },
    { month: 'Jun 2026', monthShort: 'Jun', radioRevenue: 384000, rfwRevenue: 128000, totalRevenue: 512000 },
  ],
  topEarningRadios: [
    {
      id: 1,
      name: 'Radio Deportiva Total',
      frequency: '95.70 RFW',
      city: 'Guadalajara',
      totalEarnings: 176800,
      ownRevenue: 84400,
      rfwRevenue: 92400,
      campaigns: 16,
      sponsors: 8,
      plan: 'premium',
      trend: 22.4,
    },
    {
      id: 2,
      name: 'Radio Éxito FM',
      frequency: '98.50 RFW',
      city: 'Ciudad de México',
      totalEarnings: 154200,
      ownRevenue: 75800,
      rfwRevenue: 78400,
      campaigns: 14,
      sponsors: 7,
      plan: 'premium',
      trend: 18.7,
    },
    {
      id: 3,
      name: 'Radio Industria',
      frequency: '93.50 RFW',
      city: 'Monterrey',
      totalEarnings: 138500,
      ownRevenue: 76200,
      rfwRevenue: 62300,
      campaigns: 12,
      sponsors: 6,
      plan: 'pro',
      trend: 15.2,
    },
    {
      id: 4,
      name: 'Radio Stereo Visión',
      frequency: '94.70 RFW',
      city: 'Buenos Aires',
      totalEarnings: 121300,
      ownRevenue: 65100,
      rfwRevenue: 56200,
      campaigns: 11,
      sponsors: 5,
      plan: 'pro',
      trend: 11.8,
    },
    {
      id: 5,
      name: 'Radio Élite Digital',
      frequency: '99.10 RFW',
      city: 'Madrid',
      totalEarnings: 108700,
      ownRevenue: 52900,
      rfwRevenue: 55800,
      campaigns: 9,
      sponsors: 5,
      plan: 'pro',
      trend: 9.3,
    },
    {
      id: 6,
      name: 'Radio Nueva Actitud',
      frequency: '87.90 RFW',
      city: 'Santiago',
      totalEarnings: 96400,
      ownRevenue: 47700,
      rfwRevenue: 48700,
      campaigns: 8,
      sponsors: 4,
      plan: 'pro',
      trend: 14.6,
    },
    {
      id: 7,
      name: 'Radio Estéreo Capital',
      frequency: '102.10 RFW',
      city: 'Medellín',
      totalEarnings: 89200,
      ownRevenue: 37900,
      rfwRevenue: 51300,
      campaigns: 7,
      sponsors: 4,
      plan: 'pro',
      trend: 8.2,
    },
    {
      id: 8,
      name: 'Radio Cultura Digital',
      frequency: '91.30 RFW',
      city: 'Buenos Aires',
      totalEarnings: 81500,
      ownRevenue: 38700,
      rfwRevenue: 42800,
      campaigns: 7,
      sponsors: 3,
      plan: 'free',
      trend: 16.9,
    },
  ],
  revenueStreams: [
    {
      id: 'publicidad-propia',
      label: 'Publicidad Propia',
      amount: 2084000,
      percentage: 40.6,
      icon: 'ri-radio-button-line',
      color: 'text-emerald-600',
      bgColor: 'bg-emerald-500',
    },
    {
      id: 'red-publicitaria',
      label: 'Red Publicitaria RFW',
      amount: 1640800,
      percentage: 32.0,
      icon: 'ri-global-line',
      color: 'text-violet-600',
      bgColor: 'bg-violet-500',
    },
    {
      id: 'licencias-anuales',
      label: 'Licencias Anuales',
      amount: 584000,
      percentage: 11.4,
      icon: 'ri-shield-keyhole-line',
      color: 'text-amber-600',
      bgColor: 'bg-amber-500',
    },
    {
      id: 'planes-membresia',
      label: 'Planes y Membresías',
      amount: 496000,
      percentage: 9.7,
      icon: 'ri-stack-line',
      color: 'text-sky-600',
      bgColor: 'bg-sky-500',
    },
    {
      id: 'cargos-adicionales',
      label: 'Cargos Adicionales',
      amount: 326700,
      percentage: 6.4,
      icon: 'ri-price-tag-3-line',
      color: 'text-rose-600',
      bgColor: 'bg-rose-500',
    },
  ],
};